module.exports = __webpack_public_path__ + "img/image41.a50a60e2.png";